import { MarketingCta, MarketingLayout } from "@/components/marketing/MarketingLayout";

const STEPS = [
  {
    title: "Tell us about your business",
    body: "Pick what you run — restaurant, bakery, florist, café, or another local shop — and answer a few quick questions about it. That shapes your menu terminology, categories, and storefront copy from the start.",
    tags: ["Business type", "Business details"],
  },
  {
    title: "Choose your plan",
    body: "One flat foundation covers everything a business needs to launch: your website, ordering, a CRM dashboard, and AI writing help. No commissions, ever — just one monthly price.",
    tags: ["Foundation plan", "No commission"],
  },
  {
    title: "Add your logo, photos, and menu",
    body: "Upload what you already have — logo, storefront photos, your menu or product list, in whatever format is easiest, including a photo of a printed menu. We turn it into a clean, organized storefront.",
    tags: ["Logo & photos", "Products & menu"],
  },
  {
    title: "Pick a theme, or make it yours",
    body: "Choose from six preset themes built for local businesses, or unlock custom brand colors and fonts for a one-time fee if you want it to match your exact identity.",
    tags: ["6 presets", "Custom colors"],
  },
  {
    title: "Set up ordering, payments, and your address",
    body: "Turn on pickup and delivery, connect payments, and add your hours and location — all editable any time from your dashboard later.",
    tags: ["Delivery & pickup", "Payments", "Hours & location"],
  },
  {
    title: "Preview, then go live",
    body: "Check your storefront on mobile and desktop, make last quick edits, and publish — either on a free BuildHof address or your own domain.",
    tags: ["Storefront preview", "Your own domain"],
  },
];

export function MarketingHowPage() {
  return (
    <MarketingLayout activePath="/how-it-works">
      <section className="how-hero" data-testid="public-how-content">
        <div className="wrap">
          <span className="eyebrow">How it works</span>
          <h1 className="headline" data-testid="public-how-title">
            From &quot;just an idea&quot; to <em>live and taking orders,</em> in one guided setup.
          </h1>
          <p className="sub" data-testid="public-how-body">
            No agencies, no tutorials, no code. Answer a few questions about your business and we build the rest around them.
          </p>
        </div>
      </section>

      <section className="steps" data-testid="how-steps">
        <div className="wrap">
          {STEPS.map((step, index) => (
            <div className="step-row" key={step.title} data-testid={`how-step-${index + 1}`}>
              <div className="step-num">{index + 1}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.body}</p>
                <div className="step-tags">
                  {step.tags.map((tag) => <span className="step-tag" key={tag}>{tag}</span>)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="promise-band" data-testid="how-promise">
        <div className="wrap">
          <div className="promise-grid">
            <div>
              <h3>&lt; 1 hour</h3>
              <p>Typical time to finish setup once your menu and photos are ready.</p>
            </div>
            <div>
              <h3>0% commission</h3>
              <p>What customers pay is what reaches your account, always.</p>
            </div>
            <div>
              <h3>1 flat price</h3>
              <p>Everything you need to launch, in a single monthly plan.</p>
            </div>
          </div>
        </div>
      </section>

      <MarketingCta
        title="See it for yourself"
        body="Start onboarding — nothing's charged until you're ready to go live."
      />
    </MarketingLayout>
  );
}
